import * as PropTypes from 'prop-types';
import * as React from 'react';
import { Alert } from 'reactstrap';
import { HttpStatusProviderProps } from './HttpStatusProvider';

const PAGE_NOT_FOUND = 404;

class NotFound extends React.Component<any, any> {
    public static contextTypes = {
        setHttpStatus: PropTypes.func
    };

    public context: Partial<HttpStatusProviderProps>;

    public render() {
        const { setHttpStatus } = this.context;

        // If the function to set the http status has been passed through
        // the context (server-side only), notify the server that the page
        // has not been found by setting the status to 404
        setHttpStatus && setHttpStatus(PAGE_NOT_FOUND);

        return <Alert color="danger">Page not found</Alert>;
    }
}
export default NotFound;



// WEBPACK FOOTER //
// ./src/client/components/NotFound.tsx